import {SelectProps, Select} from "antd";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {useEffect} from "react";

interface BaseDataSelectProps extends SelectProps {
    name: string | any;
    appendNull?: boolean;
    nullLabel?: string;
    defaultSelectFirst?:boolean
}

function initProps(): BaseDataSelectProps {
    return {
        name: {},
        appendNull: true,
        nullLabel: '无',
        defaultSelectFirst: false
    }
}

function BaseDataSelect(props: BaseDataSelectProps) {
    const {appendNull, name, nullLabel, defaultSelectFirst, ...otherProps}: BaseDataSelectProps = {...(initProps()), ...props};
    const baseDataState: any = useSelector<RootState>(root => root.baseData);
    let obj: any;
    if ((typeof name) == "string") {
        obj = baseDataState[name] ?? [];
    } else {
        obj = name;
    }

    useEffect(()=>{
        if(obj && obj.length && !otherProps.value && defaultSelectFirst){
            otherProps?.onChange?.(obj[0].key, obj[0]);
        }
    },[obj,otherProps.value]);

    return (
        <Select showSearch optionFilterProp={'children'} {...otherProps} placeholder={'请选择'}>
            {appendNull ? (<Select.Option key={null} value={null}>{nullLabel}</Select.Option>) : null}
            {obj.map((item: any) => (
                <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
            ))}
        </Select>
    )
}

export default BaseDataSelect;
